import { IProjectsById } from '@/features/projects/models/IProject';
import useStore from '@/lib/store';
import { useTranslation } from 'react-i18next';

export const Infos = ({
  items,
  isLoading,
}: {
  items: IProjectsById;
  isLoading: boolean;
}) => {
  const { t } = useTranslation();
  const { plants } = useStore();

  return (
    <div className="grid grid-cols-12 gap-y-[29px]">
      <div className="col-span-12">
        <p className="text-xs text-gray-graphite font-medium uppercase">
          {t('general.information')}
        </p>
      </div>

      <div className="col-span-3">
        <div className="flex flex-col">
          <p className="text-gray-arsenic text-xs">{t('district')}:</p>
          <div className="flex items-center gap-[6px]">
            {isLoading ? (
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
            ) : (
              <p className="text-base text-midnight-default font-medium">
                {items.region_name}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="col-span-3">
        <div className="flex flex-col">
          <p className="text-gray-arsenic text-xs">{t('city')}:</p>
          <div className="flex items-center gap-[6px]">
            {isLoading ? (
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
            ) : (
              <>
                <p className="text-base text-midnight-default font-medium">
                  {items.district_name}
                </p>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="col-span-3">
        <div className="flex flex-col">
          <p className="text-gray-arsenic text-xs">{t('farmer.stir')}:</p>
          <div className="flex items-center gap-[6px]">
            {isLoading ? (
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
            ) : (
              <>
                <p className="text-base text-midnight-default font-medium">
                  {items.inn}
                </p>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="col-span-3">
        <div className="flex flex-col">
          <p className="text-gray-arsenic text-xs">{t('cadastral.number')}:</p>
          <div className="flex items-center gap-[6px]">
            {isLoading ? (
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
            ) : (
              <p className="text-base text-midnight-default font-medium">
                {items.parent_cad_number}
              </p>
            )}
          </div>
        </div>
      </div>

      <div className="col-span-3">
        <div className="flex flex-col">
          <p className="text-gray-arsenic text-xs">{t('area')}:</p>
          <div className="flex items-center gap-[6px]">
            {isLoading ? (
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
            ) : (
              <p className="text-base text-midnight-default font-medium">
                {items.area || 0} {t('hectare')}
              </p>
            )}
          </div>
        </div>
      </div>

      {/* <div className="col-span-3">
        <div className="flex flex-col">
          <p className="text-gray-arsenic text-xs">
            {t('farmer.water.supply')}:
          </p>
          <div className="flex items-center gap-[6px]">
            {isLoading ? (
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
            ) : (
              <p className="text-base text-midnight-default font-medium">
                {items.waterity_level}{' '}
                <span>{items.waterity_level && '%'}</span>
              </p>
            )}
          </div>
        </div>
      </div> */}
      <div className="col-span-3">
        <div className="flex flex-col">
          <p className="text-gray-arsenic text-xs">{t('plant.name')}:</p>
          <div className="flex items-center gap-[6px]">
            {isLoading ? (
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
            ) : (
              <p className="text-base text-midnight-default font-medium">
                {plants?.find((plant) => plant.id == items.plant_id)?.name}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="col-span-6">
        <div className="flex flex-col">
          <p className="text-gray-arsenic text-xs">{t('farmer')}:</p>
          <div className="flex items-center gap-[6px]">
            {isLoading ? (
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
            ) : (
              <p className="text-base text-midnight-default font-medium ">
                {items.farmer_name}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
